
import { Question } from '../types';

export const fiqh101QuestionsAdditional: Question[] = [
  {
    id: 'fiqh131',
    text: 'According to the course, what principle determines whether touching someone of the opposite gender breaks wuḍū\'?',
    type: 'single',
    options: [
      { id: 'a', text: 'It always breaks wuḍū\' regardless of madhab', isCorrect: false },
      { id: 'b', text: 'It depends on which madhab one follows', isCorrect: true },
      { id: 'c', text: 'It only breaks wuḍū\' if done with intention', isCorrect: false },
      { id: 'd', text: 'It never breaks wuḍū\' according to any madhab', isCorrect: false }
    ],
    explanation: 'The course explains that in the Shāfi\'ī madhab, touching a person of the opposite gender breaks wuḍū\' (referring to مس المرأة), while in the Ḥanafī madhab it does not. This is an example of valid difference of opinion among madhabs.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh132',
    text: 'What is the status of debts after a person\'s death according to Islamic law as explained in the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Heirs inherit the debts and must pay them', isCorrect: false },
      { id: 'b', text: 'No one inherits debts in the dunyā, but the deceased remains accountable in the ākhirah', isCorrect: true },
      { id: 'c', text: 'Debts are completely forgiven upon death', isCorrect: false },
      { id: 'd', text: 'Debts are paid from the estate before distributing inheritance', isCorrect: true }
    ],
    explanation: 'According to the course, in Islam no one inherits debts in the dunyā (this world), but in the ākhirah (hereafter) the deceased will be asked about those debts. However, debts should be paid from the person\'s estate before distributing inheritance.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh133',
    text: 'According to the course, what was the purpose of Imam Bukhari writing Sahih Bukhari?',
    type: 'single',
    options: [
      { id: 'a', text: 'To create a new madhab', isCorrect: false },
      { id: 'b', text: 'To teach his students how to deduce rulings from hadith', isCorrect: true },
      { id: 'c', text: 'To collect all authentic hadith in one place', isCorrect: false },
      { id: 'd', text: 'To refute fabricated hadith only', isCorrect: false }
    ],
    explanation: 'According to the course, Imam Bukhari\'s primary purpose in compiling Sahih Bukhari was to teach his students how to deduce rulings from hadith (ijtihad, istinbat, and istikhraj). The book was a byproduct of this educational goal, not merely a compilation of authentic hadith.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh134',
    text: 'What is the difference between "Lafdh" and "Ma\'nah" as explained in the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Lafdh is the textual source, Ma\'nah is the interpretation', isCorrect: false },
      { id: 'b', text: 'Lafdh is literal wording, Ma\'nah is the meaning/interpretation', isCorrect: true },
      { id: 'c', text: 'Lafdh is Arabic terms, Ma\'nah is translated terms', isCorrect: false },
      { id: 'd', text: 'Lafdh is opinion, Ma\'nah is consensus', isCorrect: false }
    ],
    explanation: 'According to the course, Lafẓ (لفظ) refers to the way the word is said - including spelling, pronunciation, grammar, and language - while Ma\'nah (معنة) refers to the meaning of the word or the specific manifestation of the contents.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh135',
    text: 'According to the course, what is the role of the \'ulamā\' after the Prophet ﷺ?',
    type: 'single',
    options: [
      { id: 'a', text: 'To create new religious teachings', isCorrect: false },
      { id: 'b', text: 'To rectify changes in meaning and clarify the correct interpretation', isCorrect: true },
      { id: 'c', text: 'To replace the authority of the Prophet ﷺ', isCorrect: false },
      { id: 'd', text: 'To abrogate previous revelations', isCorrect: false }
    ],
    explanation: 'According to the course, the Prophet ﷺ said the \'ulamā\' are heirs of prophets. Their role is that whenever people change the meaning of the word of Allah, the \'ulamā\' of the ummah will rectify the change and clarify the meaning, preserving the correct understanding of revelation.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh136',
    text: 'What does the course explain about the statement "اِجْمَاعُ الأُمَّةِ حُجَّةٌ وَاخْتِلَافُ الأمَّةِ رَحْمَةٌ"?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It is an authentic hadith of the Prophet ﷺ', isCorrect: false },
      { id: 'b', text: 'It means "The consensus of the ummah is a proof and the difference of the ummah is a mercy"', isCorrect: true },
      { id: 'c', text: 'It is a logical conclusion scholars came to, not an authentic narration', isCorrect: true },
      { id: 'd', text: 'It means uniformity is more important than diversity in Islamic law', isCorrect: false }
    ],
    explanation: 'The course explains that this statement, meaning "The consensus of the ummah is a proof and the difference of the ummah is a mercy," is not an authentic hadith attributable to the Prophet ﷺ, but rather a logical conclusion that scholars came to. It expresses the value of both consensus and legitimate scholarly differences.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh137',
    text: 'What sources of fiqh did the course identify as the four main ones?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The Qur\'ān', isCorrect: true },
      { id: 'b', text: 'The Sunnah of the Prophet ﷺ', isCorrect: true },
      { id: 'c', text: 'Consensus (Ijmā\')', isCorrect: true },
      { id: 'd', text: 'Analogical reasoning (Qiyās)', isCorrect: true },
      { id: 'e', text: 'Personal opinion (Ra\'y)', isCorrect: false }
    ],
    explanation: 'According to the course, the four main sources of fiqh are: the Qur\'ān, the Sunnah of the Prophet ﷺ, consensus (Ijmā\'), and analogical reasoning (Qiyās).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh138',
    text: 'According to the course, what is the relationship between ijtihād and taqlīd?',
    type: 'single',
    options: [
      { id: 'a', text: 'They are contradictory approaches that cannot coexist', isCorrect: false },
      { id: 'b', text: 'They began simultaneously and are complementary aspects of Islamic legal tradition', isCorrect: true },
      { id: 'c', text: 'Ijtihād replaced taqlīd in later Islamic history', isCorrect: false },
      { id: 'd', text: 'Taqlīd is for scholars, ijtihād is for laypeople', isCorrect: false }
    ],
    explanation: 'According to the course, "The story of taqlīd and the story of ijtihād started on the same day." They are complementary aspects of Islamic legal tradition, with taqlīd (following qualified scholars) being appropriate for most people while ijtihād (independent reasoning) is for qualified scholars.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh139',
    text: 'What does the course identify as one of the main purposes of compiling hadith?',
    type: 'single',
    options: [
      { id: 'a', text: 'To preserve Arabic language', isCorrect: false },
      { id: 'b', text: 'To derive fiqh (legislation)', isCorrect: true },
      { id: 'c', text: 'To document historical events only', isCorrect: false },
      { id: 'd', text: 'To create new religious practices', isCorrect: false }
    ],
    explanation: 'According to the course, one of the main purposes of compiling hadith was to derive fiqh (legislation). This is evidenced by how some of the earliest hadith compilations were organized according to fiqh topics (jāmi\' and sunan methodology).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh140',
    text: 'According to the course, what are Mukallaf and Taklīf?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Mukallaf is someone who is legally responsible', isCorrect: true },
      { id: 'b', text: 'Taklīf linguistically means burden or hardship', isCorrect: true },
      { id: 'c', text: 'Taklīf technically means meeting conditions for legal responsibility', isCorrect: true },
      { id: 'd', text: 'Mukallaf is someone who has memorized the Qur\'an', isCorrect: false }
    ],
    explanation: 'According to the course, Mukallaf (مُكَلَّف) refers to someone who is legally responsible under Islamic law. Taklīf (تَكْلِيف) linguistically means burden or hardship, and technically (iṣṭilāḥan) refers to meeting the conditions for legal responsibility in Islam.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh141',
    text: 'According to the course, who is liable for following the rulings of Islamic law (fiqh)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Muslims', isCorrect: true },
      { id: 'b', text: 'Those who are mentally present/sane', isCorrect: true },
      { id: 'c', text: 'Humans (as opposed to animals)', isCorrect: true },
      { id: 'd', text: 'Those who have reached puberty (bulūgh)', isCorrect: true },
      { id: 'e', text: 'Children under the age of puberty', isCorrect: false }
    ],
    explanation: 'According to the course, the conditions for being mukallaf (legally responsible) in Islam include being: Muslim (though some laws apply to non-Muslims in certain contexts), sane (mentally present), human, and having reached the age of puberty (bulūgh بُلُوغ/taklīf تَكْلِيف).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh142',
    text: 'What example does the course give about the need for understanding both literal meaning and context in religious rulings?',
    type: 'single',
    options: [
      { id: 'a', text: 'The case of a sick person being exempted from fasting', isCorrect: false },
      { id: 'b', text: 'The case of wiping over socks during wuḍū\'', isCorrect: false },
      { id: 'c', text: 'The case of the Prophet ﷺ giving different answers about kissing while fasting', isCorrect: true },
      { id: 'd', text: 'The case of combining prayers during travel', isCorrect: false }
    ],
    explanation: 'The course gives the example of the Prophet ﷺ giving different answers to people who asked if they could kiss their wives while fasting. He told one person no and another yes. When a companion asked about this distinction, the Prophet ﷺ explained that the first person was young with strong desires (and might not be able to control himself), while the second was older (with less risk of breaking his fast).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh143',
    text: 'According to the course, what distinguishes the categorization of impurity in Islam?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It can be both physical (ḥaqīqīyatun) and state-based (ḥukmīyyatun)', isCorrect: true },
      { id: 'b', text: 'Physical impurity can be heavy (ghalīẓatun) or light (khafīfatun)', isCorrect: true },
      { id: 'c', text: 'State-based impurity can be minor (aṣghar) or major (akbar)', isCorrect: true },
      { id: 'd', text: 'All impurities require the same cleansing method', isCorrect: false }
    ],
    explanation: 'According to the course, impurity (najāsah) in Islam is categorized as physical (ḥaqīqīyatun) or state-based (ḥukmīyyatun). Physical impurity can be heavy (ghalīẓatun) or light (khafīfatun), while state-based impurity can be minor (aṣghar, requiring wuḍū\') or major (akbar, requiring ghusl).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh144',
    text: 'What example does the course give of a situation where different madhabs were applied to create appropriate solutions?',
    type: 'single',
    options: [
      { id: 'a', text: 'Following microphones in prayer', isCorrect: false },
      { id: 'b', text: 'The missing husbands case in partition-era India', isCorrect: true },
      { id: 'c', text: 'The prohibition of music', isCorrect: false },
      { id: 'd', text: 'The number of raka\'āt in Tarawīḥ prayers', isCorrect: false }
    ],
    explanation: 'The course gives the example of partition-era India, where many husbands went missing during the mass migrations and violence. The strict Ḥanafī position (dominant in the region) would have been impractical and harmful as it required certainty of death or a court ruling for each case. Scholars adopted the more lenient Mālikī position, which allowed wives to remarry after a waiting period.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh145',
    text: 'According to the course, how does the process of bayān (elaboration) work in understanding Islamic texts?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It helps explain verses that cannot be understood through literal translation alone', isCorrect: true },
      { id: 'b', text: 'The Sunnah acts as a bayān (commentary) of the Qur\'ān', isCorrect: true },
      { id: 'c', text: 'The Qur\'ān sometimes provides bayān of itself', isCorrect: true },
      { id: 'd', text: 'Bayān allows scholars to create entirely new meanings not connected to the original text', isCorrect: false }
    ],
    explanation: 'According to the course, bayān (elaboration) is a process that helps explain verses that cannot be understood through literal translation alone. The Sunnah acts as a bayān (commentary) of the Qur\'ān, and the Qur\'ān sometimes provides bayān of itself. This process is essential for proper understanding but does not allow creating entirely new meanings disconnected from the text.',
    topic: 'fiqh101'
  }
];
